import { AxiosResponse } from 'axios';
import { DeletePurchaseCriteriaRequest, PurchaseCriteriaRequest } from '@/main/models/request';
import { PurchaseCriteriaResponse } from '@/main/models/response/purchaseCriteriaResponse';
import { Result } from '../../models/common/resultResponse';
import { api } from '../base/api';
import { IPurchaseCriteriaApi } from '../base';

const baseRoute: string = 'PurchaseCriteria';

export class PurchaseCriteriaApi extends IPurchaseCriteriaApi {
  savePurchaseCriteria(
    request: PurchaseCriteriaRequest
  ): Promise<AxiosResponse<Result<PurchaseCriteriaResponse>>> {
    return api.post(`${baseRoute}`, request);
  }

  deletePurchaseCriteria(
    request: DeletePurchaseCriteriaRequest
  ): Promise<AxiosResponse<Result<PurchaseCriteriaResponse>>> {
    return api.post(`${baseRoute}/delete`, request);
  }
}
